/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_PromoInputs */

const en_pricing_promo = /** @type {(inputs: Pricing_PromoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch promo · save up to 25% on yearly plans`)
};

const id_pricing_promo = /** @type {(inputs: Pricing_PromoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promo peluncuran · hemat sampai 25% untuk paket tahunan`)
};

/**
* | output |
* | --- |
* | "Launch promo · save up to 25% on yearly plans" |
*
* @param {Pricing_PromoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_promo = /** @type {((inputs?: Pricing_PromoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_PromoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_promo(inputs)
	return en_pricing_promo(inputs)
});